module.exports = __webpack_public_path__ + "img/aesthetic_medical_clinic.a4e9823e.png";